import {  healthApi } from "@api";
import { ComponentBread, ComponentHeader, StyledCreateLg } from "@components";
import { PATH_DEPO_RECORDS,  PATH_HEALTH_RECORDS, PATH_HEALTH_RECORDS_CREATE } from "@configs";
import {  IHealthRecord } from "@interfaces";

import { setLoading } from "@redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import {  HealthRecordForm } from "@modules";

export const PageCreateHealthRecord = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [record, setRecord] = useState<IHealthRecord>();
  useEffect(() => {
    if (id) {
      fetchContraceptionById();
    }
  }, [id]);
  const data = [
    {
      title: <a href={PATH_HEALTH_RECORDS || ""}>{t('page.Reproductive_Health_Records')}</a>,
    },
    {
      title: <a href={PATH_HEALTH_RECORDS_CREATE || ""}>{t('page.Add_New_Record')}</a>,
    },
  ];
  const fetchContraceptionById = async () => {
    try {
      dispatch(setLoading(true));
      const res = await healthApi.detail(id);
      setRecord(res.data);
    } catch (err: any) {
      history.push(PATH_DEPO_RECORDS);
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      <ComponentHeader title={t("page.Reproductive_Health_Records_Panel")} />
      <StyledCreateLg>
        <ComponentBread pages={data} />
        <HealthRecordForm record={record} />
      </StyledCreateLg>
    </>
  );
};
